/* FAQ accordion — ported from homepage-v3/script.js (faqReadMore +
   faqFixedHeight).
   - Answers show two lines, with a Read more / Read less toggle under any
     answer longer than that. Closing a question folds its answer back.
   - The card is measured with each answer open (and expanded) in turn and
     holds the tallest as its min-height, so switching questions never
     resizes the card or the photo beside it.
   The <details> share a name, so opening one closes the others (native).
   Re-initialises when the section is re-rendered in the theme editor. */
(function () {
    function readMore(root) {
        var answers = Array.prototype.slice.call(root.querySelectorAll('.faq-answer'));

        answers.forEach(function (answer) {
            var text = answer.querySelector('p');
            if (!text) return;

            var button = document.createElement('button');
            button.type = 'button';
            button.className = 'faq-more';
            button.textContent = 'Read more';
            button.setAttribute('aria-expanded', 'false');
            answer.appendChild(button);

            var item = answer.closest('.faq-item');

            function setExpanded(open) {
                answer.classList.toggle('is-expanded', open);
                button.textContent = open ? 'Read less' : 'Read more';
                button.setAttribute('aria-expanded', String(open));
            }

            // Hide the button when two lines already hold the whole answer.
            // A closed <details> measures as zero, so this is re-run on open.
            function check() {
                if (answer.classList.contains('is-expanded')) return;
                button.hidden = text.scrollHeight <= text.clientHeight + 1;
            }

            button.addEventListener('click', function () {
                setExpanded(!answer.classList.contains('is-expanded'));
            });

            if (item) {
                item.addEventListener('toggle', function () {
                    if (item.open) { check(); } else { setExpanded(false); }
                });
            }

            check();
            window.addEventListener('load', check);
            window.addEventListener('resize', check);
        });
    }

    function fixedHeight(root) {
        var list = root.querySelector('[data-faq-list]');
        var card = list && list.closest('.faq-grid');
        if (!list || !card) return;
        var items = Array.prototype.slice.call(list.querySelectorAll('.faq-item'));
        if (!items.length) return;

        function measure() {
            if (!card.isConnected) return;
            var wasOpen = items.map(function (item) { return item.open; });
            // Measured with every answer expanded past its two-line clamp, so
            // clicking Read more never grows the card or the photo beside it.
            var answers = items.map(function (item) { return item.querySelector('.faq-answer'); });
            var wasExpanded = answers.map(function (a) { return !!a && a.classList.contains('is-expanded'); });
            answers.forEach(function (a) { if (a) a.classList.add('is-expanded'); });
            list.style.minHeight = '';
            card.style.minHeight = '';

            var tallest = card.offsetHeight;
            items.forEach(function (item) {
                items.forEach(function (other) { other.open = other === item; });
                tallest = Math.max(tallest, card.offsetHeight);
            });

            items.forEach(function (item, i) { item.open = wasOpen[i]; });
            answers.forEach(function (a, i) { if (a) a.classList.toggle('is-expanded', wasExpanded[i]); });
            card.style.minHeight = tallest + 'px';
        }

        measure();
        window.addEventListener('load', measure);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);

        var resizeTimer = null;
        window.addEventListener('resize', function () {
            window.clearTimeout(resizeTimer);
            resizeTimer = window.setTimeout(measure, 150);
        });
    }

    function initFaq(root) {
        if (!root || root.dataset.faqReady) return;
        root.dataset.faqReady = 'true';
        // Read more runs first so its buttons exist when the card is measured.
        readMore(root);
        fixedHeight(root);
    }

    function initAll(scope) {
        Array.prototype.forEach.call((scope || document).querySelectorAll('[data-faq]'), initFaq);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
        initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
        initAll(event.target);
    });

    // Theme editor: selecting a question opens it.
    document.addEventListener('shopify:block:select', function (event) {
        var item = event.target.closest ? event.target.closest('.faq-item') : null;
        if (item && item.closest('[data-faq]')) item.open = true;
    });
}());
